import { render, staticRenderFns } from "./LEDDashboard.vue?vue&type=template&id=2a50fc04&scoped=true&"
import script from "./LEDDashboard.vue?vue&type=script&lang=js&"
export * from "./LEDDashboard.vue?vue&type=script&lang=js&"
import style0 from "./LEDDashboard.vue?vue&type=style&index=0&id=2a50fc04&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a50fc04",
  null
  
)

export default component.exports